import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import { TrainingMode } from "../../store/tg-model-store.tsx";
import styles from "./TrainingModeSelection.module.scss";
import { useEffect } from "react";
import { useAppStore } from "../../../../../hooks/useStores.tsx";

type TrainingModeSelectionProps = {
	onTrainingModeSelect: (mode: TrainingMode) => void;
};

const TrainingModeSelection = ({ onTrainingModeSelect }: TrainingModeSelectionProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.create.steps.trainingMode" });
	const { tgStore } = useAppStore();
	const { tgModelStore } = tgStore;

	useEffect(() => {
		if (tgModelStore.modelForm.training_mode != undefined) {
			onTrainingModeSelect(tgModelStore.modelForm.training_mode)
		}
	}, [])

	return (
		<Box className={styles.stepWrapper}>
			<Typography className={styles.header}>{t("header")}</Typography>
			<Box className={styles.cards}>
				<Box className={styles.card}>
					<Box>
						<Box className={styles.cardNameWrapper}>
							<Typography className={styles.cardName}>{t("fullyAutomated.title")}</Typography>
						</Box>
						<Typography className={styles.cardDesc}>{t("fullyAutomated.description")}</Typography>
					</Box>
					<BriaButton
						className={styles.cardButton}
						buttonType="secondaryMedium"
						onClick={() => onTrainingModeSelect(TrainingMode.FULLY_AUTOMATED)}
					>
						{t("selectButton")}
					</BriaButton>
				</Box>

				<Box className={styles.card}>
					<Box>
						<Box className={styles.cardNameWrapper}>
							<Typography className={styles.cardName}>{t("expert.title")}</Typography>
						</Box>
						<Typography className={styles.cardDesc}>{t("expert.description")}</Typography>
					</Box>
					<BriaButton
						className={styles.cardButton}
						buttonType="secondaryMedium"
						onClick={() => onTrainingModeSelect(TrainingMode.EXPERT)}
					>
						{t("selectButton")}
					</BriaButton>
				</Box>
			</Box>
		</Box>
	);
};

export default observer(TrainingModeSelection);
